import { QueryParams } from '../commonMixed';

export class GetEmailSecondaryReceiversRequest extends QueryParams {
  ids!: string[];
  status!: string;
}
